const gameData = [
  {
    question: "I've been on television before",
    answer: true,
    explainer:
      "I did indeed have a slight brush with stardom in my early teens as a contestant in a game show where I managed to spell the word 'pineapple' wrong (I'm still bad at spelling)",
  },
  {
    question: "I ran a dropshipping business in my teens",
    answer: false,
    explainer:
      "Never tried it! I did have a side hustle reselling clothes though, those were good times",
  },
  {
    question: "My first job was working retail",
    answer: false,
    explainer:
      "I did work retail as a cashier but my first job was actually delivering newspapers locally!",
  },
  {
    question: "I've been in a newspaper before",
    answer: false,
    explainer:
      "As far as I know, I haven't been in a newspaper before but who knows maybe I'm lurking in the background of a picture somewhere?",
  },
  {
    question: "I prefer physical books to ebooks",
    answer: true,
    explainer:
      "Who doesn't like the feel of paper over a Kindle? Although recently my bookshelf has been overflowing a little...",
  },
  {
    question: "I'm a morning person",
    answer: false,
    explainer:
      "I used to wake up early to go to the gym before class but I just fell asleep everywhere. Wouldn't say I'm a night owl either though",
  },
  {
    question: "One of the sports I play is archery",
    answer: true,
    explainer:
      "Although it's been a while since I've practiced, I was a part of my University's archery club and hold a state record!",
  },
  {
    question: "I used to have a pet turtle",
    answer: true,
    explainer:
      "Shelly used to live in a special enclosure near the front of our house and enjoyed walking around",
  },
  {
    question: "My room is decorated with RGB lights on the wall",
    answer: false,
    explainer:
      "Love the aesthetic but I'm sure there are betters ways to waste electricity (mining bitcoin perhaps?)",
  },
  {
    question: "I've been on the radio before",
    answer: true,
    explainer:
      "I did a work experience placement at SBS once and got to be on a live radio segment!",
  },
];

export default gameData;
